import {ContestAdminList, ContestAdminCreate, ContestAdminEdit} from './pages/contestAdmin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import FRi18n from 'ra-language-french';
import React from 'react';
import {Admin, AppBar, fetchUtils, Layout, Resource} from 'react-admin';
import {Route} from 'react-router-dom';
import TnrDashboard from './pages/tnrDashboard';
import apiURL from './apiURL';
import {
    LazyUserCreate,
    LazyUserEdit,
    LazyUserList,
    LazyEventCreate,
    LazyEventEdit,
    LazyEventList,
    LazyEventShow,
    LazyPlaceCreate,
    LazyPlaceEdit,
    LazyPlaceList,
} from './LazyPages';
import './AdminTableNoWrap.css';
import {CatalogCreate, CatalogEdit, CatalogList} from './pages/catalogs';
import {GiftCreate, GiftList} from './pages/gifts';
import {FictitiousEventCreate, FictitiousEventEdit, FictitiousEventList} from './pages/fictitiousEvents';
import {InterludeCategoryCreate, InterludeCategoryEdit, InterludeCategoryList} from './pages/interludeCategories';
import {InterludeCreate, InterludeEdit, InterludeList} from './pages/interludes';
import {IntroVideoCreate, IntroVideoEdit, IntroVideoList} from './pages/introVideos';
import {MediaCreate, MediaEdit, MediaList} from './pages/medias';
import {MedleyCreate, MedleyEdit, MedleyList} from './pages/medleys';

import {SongGenreCreate, SongGenreEdit, SongGenreList} from './pages/songgenres';
import {SongLangCreate, SongLangEdit, SongLangList} from './pages/songlangs';
import {SongRegionCreate, SongRegionEdit, SongRegionList} from './pages/songregions';
import {CatalogSongSelector, SongCreate, SongEdit, SongList} from './pages/songs';
import {
    EventInterludeCategorySelector,
    EventInterludeSelector,
    EventIntroVideoSelector,
    EventMedleySelector,
} from './pages/eventContentSelectors';
import {SongSuggestionArchiveList, SongSuggestionList} from './pages/songSuggestions';
import {TranslationCreate, TranslationEdit, TranslationList} from './pages/translations';
import {BoxOfferCreate, BoxOfferEdit, BoxOfferList} from './pages/boxOffers';
import {BoxOptionCreate, BoxOptionEdit, BoxOptionList} from './pages/boxOptions';
import {BoxDeliveryZoneCreate, BoxDeliveryZoneEdit, BoxDeliveryZoneList} from './pages/boxDeliveryZones';
import {BoxReservationEdit, BoxReservationList} from './pages/boxReservations';
import {LoyaltyProspectList} from './pages/loyaltyProspects';
import {BoxSettingsCreate, BoxSettingsEdit, BoxSettingsList} from './pages/boxSettings';
import {BoxContractIdentityCreate, BoxContractIdentityEdit, BoxContractIdentityList} from './pages/boxContractIdentities';
import {
    BoxContractSettingsCreate,
    BoxContractSettingsEdit,
    BoxContractSettingsList,
} from './pages/boxContractSettings';
// pages

import authProvider from './providers/authProvider';
import dataProvider from './providers/dataProvider';
import GlobalLoadingOverlay from './GlobalLoadingOverlay';
import AdminMenu from './AdminMenu';
import theme from './theme';


const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({Accept: 'application/json'});
    }
    const token = localStorage.getItem('auth') || '';
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
};

const i18nProvider = polyglotI18nProvider(() => FRi18n, 'fr', {allowMissing: true, onMissingKey: (key, _, __) => key});

const myDataProvider = dataProvider(apiURL, httpClient);

const FixedAppBar = (props) => (
    <AppBar {...props} container={React.Fragment} />
);

const FixedLayout = (props) =>
    React.createElement(
        React.Fragment,
        null,
        React.createElement(Layout, {...props, appBar: FixedAppBar, menu: AdminMenu}),
        React.createElement(GlobalLoadingOverlay)
    );

const customRoutes = [
    <Route
        exact
        path="/song-suggestion-archives"
        render={(routeProps) => (
            <SongSuggestionArchiveList
                {...routeProps}
                resource="song-suggestion"
                basePath="/song-suggestion"
            />
        )}
    />,

    // ========================================================
    // ADMIN DÉMO
    // Même Resource/API que l'admin normal.
    // Seuls le chemin, le filtre et les valeurs par défaut changent.
    // ========================================================

    <Route
        exact
        path="/demo/song"
        render={(routeProps) => (
            <SongList
                {...routeProps}
                resource="song"
                basePath="/demo/song"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/song/create"
        render={(routeProps) => (
            <SongCreate
                {...routeProps}
                resource="song"
                basePath="/demo/song"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/song/:id"
        render={(routeProps) => (
            <SongEdit
                {...routeProps}
                id={routeProps.match.params.id}
                resource="song"
                basePath="/demo/song"
                demoMode
            />
        )}
    />,

    <Route
        exact
        path="/demo/interludecategory"
        render={(routeProps) => (
            <InterludeCategoryList
                {...routeProps}
                resource="interludecategory"
                basePath="/demo/interludecategory"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/interludecategory/create"
        render={(routeProps) => (
            <InterludeCategoryCreate
                {...routeProps}
                resource="interludecategory"
                basePath="/demo/interludecategory"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/interludecategory/:id"
        render={(routeProps) => (
            <InterludeCategoryEdit
                {...routeProps}
                id={routeProps.match.params.id}
                resource="interludecategory"
                basePath="/demo/interludecategory"
                demoMode
            />
        )}
    />,

    <Route
        exact
        path="/demo/interlude"
        render={(routeProps) => (
            <InterludeList
                {...routeProps}
                resource="interlude"
                basePath="/demo/interlude"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/interlude/create"
        render={(routeProps) => (
            <InterludeCreate
                {...routeProps}
                resource="interlude"
                basePath="/demo/interlude"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/interlude/:id"
        render={(routeProps) => (
            <InterludeEdit
                {...routeProps}
                id={routeProps.match.params.id}
                resource="interlude"
                basePath="/demo/interlude"
                demoMode
            />
        )}
    />,

    <Route
        exact
        path="/demo/introvideo"
        render={(routeProps) => (
            <IntroVideoList
                {...routeProps}
                resource="introvideo"
                basePath="/demo/introvideo"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/introvideo/create"
        render={(routeProps) => (
            <IntroVideoCreate
                {...routeProps}
                resource="introvideo"
                basePath="/demo/introvideo"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/introvideo/:id"
        render={(routeProps) => (
            <IntroVideoEdit
                {...routeProps}
                id={routeProps.match.params.id}
                resource="introvideo"
                basePath="/demo/introvideo"
                demoMode
            />
        )}
    />,

    <Route
        exact
        path="/demo/medley"
        render={(routeProps) => (
            <MedleyList
                {...routeProps}
                resource="medley"
                basePath="/demo/medley"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/medley/create"
        render={(routeProps) => (
            <MedleyCreate
                {...routeProps}
                resource="medley"
                basePath="/demo/medley"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/demo/medley/:id"
        render={(routeProps) => (
            <MedleyEdit
                {...routeProps}
                id={routeProps.match.params.id}
                resource="medley"
                basePath="/demo/medley"
                demoMode
            />
        )}
    />,
    <Route
        exact
        path="/event/:eventId/content/catalog/:catalogId/songs"
        render={(routeProps) => (
            <CatalogSongSelector
                {...routeProps}
                resource="song"
                basePath="/song"
                eventId={routeProps.match.params.eventId}
                catalogId={routeProps.match.params.catalogId}
            />
        )}
    />,

    <Route
        exact
        path="/catalog/:id/songs"
        render={(routeProps) => (
            <CatalogSongSelector
                {...routeProps}
                resource="song"
                basePath="/song"
                catalogId={
                    routeProps.match.params.id
                }
            />
        )}
    />,

    <Route
        exact
        path="/event/:id/content/intro"
        render={(routeProps) => (
            <EventIntroVideoSelector
                {...routeProps}
                resource="introvideo"
                basePath="/introvideo"
                eventId={routeProps.match.params.id}
            />
        )}
    />,

    <Route
        exact
        path="/event/:id/content/interlude-categories"
        render={(routeProps) => (
            <EventInterludeCategorySelector
                {...routeProps}
                resource="interludecategory"
                basePath="/interludecategory"
                eventId={routeProps.match.params.id}
            />
        )}
    />,

    <Route
        exact
        path="/event/:id/content/interludes"
        render={(routeProps) => (
            <EventInterludeSelector
                {...routeProps}
                resource="interlude"
                basePath="/interlude"
                eventId={routeProps.match.params.id}
            />
        )}
    />,

    <Route
        exact
        path="/event/:id/content/medleys"
        render={(routeProps) => (
            <EventMedleySelector
                {...routeProps}
                resource="medley"
                basePath="/medley"
                eventId={routeProps.match.params.id}
            />
        )}
    />,


    <Route
        exact
        path="/tnr"
        render={routeProps => (
            <TnrDashboard {...routeProps} />
        )}
    />,

];

const App = () => (
    <Admin
        dataProvider={myDataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        theme={theme}
        layout={FixedLayout}
        customRoutes={customRoutes}
    >
        <Resource name="user" list={LazyUserList} edit={LazyUserEdit} create={LazyUserCreate} options={{label: "Utilisateurs"}} />
        <Resource name="song" list={SongList} edit={SongEdit} create={SongCreate} options={{label: "Titres"}} />
        <Resource name="catalog" list={CatalogList} edit={CatalogEdit} create={CatalogCreate} options={{label: "Catalogues"}} />
        <Resource name="song-suggestion" list={SongSuggestionList} options={{label: "Suggestions"}} />
        <Resource name="songgenre" list={SongGenreList} edit={SongGenreEdit} create={SongGenreCreate} options={{label: "Genres"}} />
        <Resource name="songregion" list={SongRegionList} edit={SongRegionEdit} create={SongRegionCreate} options={{label: "Régions"}} />
        <Resource name="songlang" list={SongLangList} edit={SongLangEdit} create={SongLangCreate} options={{label: "Langues"}} />
        <Resource name="interludecategory" list={InterludeCategoryList} edit={InterludeCategoryEdit} create={InterludeCategoryCreate} options={{label: "Catégories d'interludes"}} />
        <Resource name="interlude" list={InterludeList} edit={InterludeEdit} create={InterludeCreate} options={{label: "Interludes"}} />
        <Resource name="introvideo" list={IntroVideoList} edit={IntroVideoEdit} create={IntroVideoCreate} options={{label: "Vidéos introduction"}} />
        <Resource name="medley" list={MedleyList} edit={MedleyEdit} create={MedleyCreate} options={{label: "Medleys"}} />
        <Resource name="place" list={LazyPlaceList} edit={LazyPlaceEdit} create={LazyPlaceCreate} options={{label: "Lieux"}} />
        <Resource name="event" list={LazyEventList} edit={LazyEventEdit} create={LazyEventCreate} show={LazyEventShow} options={{label: "Événements"}} />
        <Resource name="fictitiousevent" list={FictitiousEventList} edit={FictitiousEventEdit} create={FictitiousEventCreate} options={{label: "Événements fictifs"}} />
        <Resource name="media" list={MediaList} edit={MediaEdit} create={MediaCreate} options={{label: "Médias"}} />
        <Resource name="gift" list={GiftList} create={GiftCreate} options={{label: "Cadeaux"}} />
        <Resource name="contest-admin" list={ContestAdminList} create={ContestAdminCreate} edit={ContestAdminEdit} options={{label: "Jeux concours"}} />
        <Resource name="translation" list={TranslationList} edit={TranslationEdit} create={TranslationCreate} options={{label: "Traductions"}} />

        <Resource name="loyaltyadmin" list={LoyaltyProspectList} options={{label: "Prospects Box Boukan"}} />
        <Resource name="boxreservation" list={BoxReservationList} edit={BoxReservationEdit} options={{label: "Réservations Box"}} />
        <Resource name="boxoffer" list={BoxOfferList} edit={BoxOfferEdit} create={BoxOfferCreate} options={{label: "Offres Box"}} />
        <Resource name="boxoption" list={BoxOptionList} edit={BoxOptionEdit} create={BoxOptionCreate} options={{label: "Options Box"}} />
        <Resource name="boxdeliveryzone" list={BoxDeliveryZoneList} edit={BoxDeliveryZoneEdit} create={BoxDeliveryZoneCreate} options={{label: "Zones Box"}} />
        <Resource name="boxsettings" list={BoxSettingsList} edit={BoxSettingsEdit} create={BoxSettingsCreate} options={{label: "Paramètres Box"}} />
        <Resource name="boxcontractidentity" list={BoxContractIdentityList} edit={BoxContractIdentityEdit} create={BoxContractIdentityCreate} options={{label: "Identités contrats"}} />
        <Resource name="boxcontractsettings" list={BoxContractSettingsList} edit={BoxContractSettingsEdit} create={BoxContractSettingsCreate} options={{label: "Contrat Box"}} />
    </Admin>
);

export default App;
